import types from "actions/types"
import {get} from "lodash"
import {sortByKey} from "helpers/sorting"
import {combineReducers} from "redux"

export const departments = (state = [], action) => {
  switch (action.type) {
    case types.DEPARTMENTS_LOAD_ATTEMPT:
      return state

    case types.DEPARTMENTS_LOAD_SUCCESS:
      return get(action, 'data', [])

    case types.DEPARTMENTS_LOAD_FAILURE:
      return state

    case types.DEPARTMENTS_ADD_SUCCESS:
      return [
        ...state,
        action.data,
      ]

    case types.DEPARTMENTS_UPDATE_SUCCESS:
      const updated =  state.map(department => {
        return department.id === action.data.id
          ? action.data
          : department
      })
      return updated.sort((a, b) => a.sortOrder - b.sortOrder)

    case types.DEPARTMENTS_DELETE_SUCCESS:
      return state.filter(department => department.id !== action.data.id)

    default:
      return state
  }
}

export const workCentres = (state = [], action) => {
  switch (action.type) {
    case types.WORK_CENTRES_LOAD_ATTEMPT:
      return state

    case types.WORK_CENTRES_LOAD_SUCCESS:
      const data = get(action, 'data', [])
      return data.map(workCentre => {
        const deliveriesSummary = get(workCentre, 'deliveriesSummary', {})
        const count = get(deliveriesSummary, 'count', 0)
        return {
          hasDeliveries: count > 0,
          deliveryCount: count,
          ...workCentre,
        }
      })

    case types.WORK_CENTRES_LOAD_FAILURE:
      return state

    case types.WORK_CENTRES_ADD_SUCCESS: {
      const workCentres = get(action, 'data', [])
      return workCentres.sort((a, b) => sortByKey(a, b, 'sortOrder'))
    }

    case types.WORK_CENTRES_UPDATE_SUCCESS: {
      const workCentres = get(action, 'data', [])
      return workCentres.sort((a, b) => sortByKey(a, b, 'sortOrder'))
    }

    case types.WORK_CENTRES_DELETE_SUCCESS:
      return state.filter(workCentre => workCentre.id !== action.data.id)

    case types.DEPARTMENTS_DELETE_SUCCESS:
      return state.filter(workCentre => workCentre.departmentId !== action.data.id)

    default:
      return state
  }
}

export default combineReducers({
  departments,
  workCentres,
})